document.addEventListener("DOMContentLoaded", function() {
  const videos = document.querySelectorAll(".banner-with-popup__video[data-poster]");
  videos.forEach(video => {
    if (window.innerWidth <= 768) {
      const poster = video.getAttribute("data-poster");
      if (poster) {
        video.setAttribute("poster", poster);
      }
    }
  });
});